export let API_URL;
export let ID_URL;
export let APP_URL;
export let DOWNLOAD_BOLETO_URL;
export let PAINEL_URL;
export let ORIGIN;
export let API_IBGE;
if (process.env.NODE_ENV != 'development') {
  API_URL = 'https://api.serranaleiloes.com.br/';
  ID_URL = 'https://id.serranaleiloes.com.br/';
  APP_URL = 'https://leiloesnovaserrana.com.br/';
  DOWNLOAD_BOLETO_URL = 'https://api.serranaleiloes.com.br/';
  PAINEL_URL = 'https://painel.serranaleiloes.com.br';
  ORIGIN = 'https://painel.serranaleiloes.com.br';
  API_IBGE = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados';
} else {
  API_URL = 'https://localhost:4001/';
  ID_URL = 'https://localhost:5001/';
  APP_URL = 'http://localhost:8080/';
  DOWNLOAD_BOLETO_URL = 'https://localhost:4001/';
  PAINEL_URL = 'http://localhost:8081';
  ORIGIN = 'http://localhost:8081';
  API_IBGE = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados';
}
